/**
 * Centralne źródło danych firmowych/kontaktowych NexXsite.
 * Wszystkie komponenty i strony powinny czerpać te dane stąd, zamiast
 * duplikować adres/telefon/e-mail w wielu plikach.
 *
 * Pola w formacie {{NAZWA}} to placeholdery na dane, których jeszcze
 * nie mamy (realne liczby, NIP, współrzędne mapy) — podmienić przed
 * publikacją finalnej wersji.
 */
export const SITE = {
  name: "NexXsite",
  legalName: "NexXsite",
  domain: "https://nexxsite.pl",
  nip: "7543364885",

  address: {
    street: "ul. Jana Łangowskiego 4A",
    postalCode: "45-031",
    city: "Opole",
    region: "opolskie",
    country: "PL",
  },

  phone: "+48 509 260 511",
  phoneHref: "tel:+48509260511",
  email: "biuro@nexxsite.pl",
  openingHours: { opens: "09:00", closes: "17:00" },
  description: "Specjalizujemy się w automatyzacjach n8n i agentach AI oraz w widoczności firm w odpowiedziach asystentów AI (GEO). Uzupełniająco robimy strony WWW, SEO, reklamy, wideo UGC, opiekę IT i analitykę danych. Pracujemy z Opola dla firm w całej Polsce.",
  hours: "Pon – Pt · 9:00 – 17:00",

  social: {
    facebook: "https://www.facebook.com/profile.php?id=61592765815781",
    instagram: "https://www.instagram.com/nexxsite_pl/",
    linkedin: "https://www.linkedin.com/company/nexxsite/",
  },

  // Stały link do wizytówki Google (Profil Firmy → „Udostępnij profil”, np. https://maps.app.goo.gl/…
  // albo https://www.google.com/maps?cid=…). Nie wklejać adresu wyniku wyszukiwania — zmienia się co sesję.
  googleBusinessProfile: "",

  // Dane rejestrowe do schema.org. Puste = pomijane w JSON-LD. Uzupełnić dopiero, gdy KRS pokaże
  // nazwę NexXsite (dziś NIP 7543364885 / KRS 0001072906 figuruje jako PORAGLASS sp. z o.o.).
  registry: {
    legalName: "NexXsite (PORAGLASS sp. z o.o.)",    // np. "NexXsite sp. z o.o." — dokładnie jak w KRS
    taxID: "7543364885",        // NIP, np. "7543364885"
    vatID: "PL7543364885",        // np. "PL7543364885" (status VAT: czynny)
    foundingDate: "2023-11-23", // data wpisu do KRS, format RRRR-MM-DD
  },
  priceRange: "od 1990 zł netto",

  // Profile firmy w katalogach (Panorama Firm, Aleo, Oferteo, GoWork, Clutch, Sortlist) — pełne adresy profili.
  directories: [],

  geo: {
    lat: "50.67071537147948",
    lng: "17.9204514768607",
  },
  mapEmbedSrc: "https://www.google.com/maps?q=Jana%20%C5%81angowskiego%204A%2C%2045-031%20Opole&output=embed",
  mapLink: "https://www.google.com/maps?q=ul.+Jana+Łangowskiego+4A,+45-031+Opole",

  // Statystyki placeholderowe do paska w hero / sekcji "O nas" — do uzupełnienia realnymi danymi.
  stats: {
    yearsOnMarket: "3",
    projectsCompleted: "9",
    avgDeployDays: "14-30",
  },

  // Ceny orientacyjne — jedno miejsce dla wszystkich wzmianek cenowych
  // (Pricing.jsx, FAQ, artykuł na blogu, podstrona /uslugi/strony-internetowe,
  // FAQ usługi Reklamy). Podmień tu, zmiana rozejdzie się wszędzie.
  pricing: {
    start: "2990",
    growth: "1900",
    scale: "7900",
    landingPage: "1990",
    minAdBudget: "2000",
    // Specjalizacje — ceny „od”, netto. Te same kwoty zna agent analizujący briefy w n8n.
    n8nAutomation: "1490",   // pojedyncza automatyzacja n8n
    aiChatbot: "4900",       // chatbot / agent AI, + koszty API modelu
    n8nMaintenance: "490",   // utrzymanie n8n na serwerze klienta, miesięcznie
    geoAudit: "1490",        // audyt widoczności w AI
    geoMonthly: "990",      // GEO w abonamencie, miesięcznie
  },

  // Warunki z regulaminu, które wymagają jednorazowej decyzji biznesowej.
  legal: {
    complaintResponseDays: "30",
    noticePeriod: "30",
  },
};

export default SITE;
